export default __webpack_public_path__ + "mobil.webp";